import { getBetCalculations, BetCalculationsEnum } from '@betslip/calculation';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

export const calculateBetBuilderPossibleWin = (stake, price, currencyConfig, partnerConfig) => {
  if (!stake) return null;
  const { taxedStake } = getBetCalculations(
    [BetCalculationsEnum.TaxOnStake],
    { stake, partnerConfig },
  );
  const rounding = Math.abs(currencyConfig.rounding);
  const amount = taxedStake * price;

  return parseFloat(amount.toFixed(rounding));
};

export const betBuilderPlaceBet = (bestlipUid, stake, clientId, memberId) => swarmRequest({
  name: 'CreateBetSC',
  params: {
    BetSlipUid: bestlipUid,
    Amount: stake,
    IsPlayerBetting: !!clientId,
    ClientId: clientId,
    ExternalId: memberId,
  },
}, 'betshop_command');
